import { useCallback, useEffect, useState } from '@redneckz/uni-jsx/lib/hooks';
export const useLatestEvent = (eventBus, type, initialEvent) => {
    const [latestEvent, setLatestEvent] = useState(initialEvent || null);
    useEffect(() => eventBus.subscribe(type, (_) => setLatestEvent(_)), [eventBus, type]);
    const fireEvent = useCallback((_) => eventBus.fire(type, _), [eventBus, type]);
    return [latestEvent, fireEvent];
};
//# sourceMappingURL=useLatestEvent.js.map